@if(!fullyLoaded) {
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">Payments</h4>
        </div>
    </div>
</div>
  <div class="row justify-content-center">
    <div id="status">
        <div class="bouncing-loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
}
@else {
<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">Payments of {{invoice.partner.name}} (Invoice {{invoice.invoiceNumber}})</h4>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
      <form [formGroup]="form">
          <label for="example-email" class="form-label mb-3">New payment</label>
        <div class="row">
            <div class="mb-3 col-md-2 col-sm-10 col-xs-10">
                <input
              formControlName="amount"
              type="text"
              class="form-control"
              placeholder="Amount"
              number
            />
            </div>
            <div class="mb-3 col-md-3 col-sm-10 col-xs-10">
                <input
                formControlName="description"
              type="text"
              class="form-control"
              placeholder="Description"
            />
          </div>
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10">
            <input formControlName="date" type="date" class="form-control" />
          </div>
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10">
            <div class="input-group" id="timepicker-input-group1">
              <input type="text" class="form-control" formControlName="time" hhmmss>
              <span class="input-group-text"><i class="ri-time-line"></i></span>
          </div>
          </div>
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10">
            <button class="btn btn-secondary" (click)="addPayment()" [disabled]="this.form.invalid || form.controls['amount'].value <= 0">Add</button>
          </div>
          <div class="table-responsive-sm col-md-10">
            <table
              datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger"
              class="table dt-responsive table-striped table-centered mb-0"
            >
              <thead class="table-dark">
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10">
            @if(submitting) {
            <button class="btn btn-secondary" disabled>
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Submitting...
            </button>
            } @else {
            <button class="btn btn-secondary" (click)="savePayments()">
              Save
            </button>
            } @if(error){<span class="p-2 text-danger">{{ error }}</span
            >}
          </div>
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10 align-content-center">
            <h4 class="text-center">
              Paid: {{form.controls['paidAmount'].value}}
            </h4>
          </div>
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10 align-content-center">
            <h4 class="text-center">
              Left to pay: {{invoice.amount - form.controls['paidAmount'].value}}
            </h4>
          </div>
          <div class="mb-3 col-md-2 col-sm-10 col-xs-10 align-content-center">
            <h4 class="text-center">
              Total due: {{invoice.amount}}
            </h4>
          </div>
        </div>
      </form>
    </div>
  </div>
}